<!-- this creates a google map on the page with the given lat/lng from -->
<!-- the component as the initial center of the map: -->
<div class="map-container">
    <agm-map (mapReady)="onMapReady($event)" [latitude]="Marker?.lat ? Marker?.lat :25.276987"
        [longitude]="Marker?.lng ? Marker?.lng : 55.296249" (mapClick)="mapClicked($event)" [zoom]="Marker?.lat?15:10">
        <agm-marker *ngIf="Marker" [latitude]="Marker?.lat" [longitude]="Marker?.lng"></agm-marker>
    </agm-map>
</div>